import type { UpsellVariantId } from '../utils/metaPixel'

export type Upsell = {
  id: UpsellVariantId
  title: string
  price: number
  compareAt?: number
  description: string
  thumbLabel: string
  image?: string
  starterOnly?: boolean
}

export const upsells: Upsell[] = [
  {
    id: 'upgrade',
    title: 'Upgrade to Complete',
    price: 7,
    description:
      'Emotions & Calm Corner Pack, The Focus Pack and free updates for life — the three things you just left behind.',
    thumbLabel: 'COMPLETE COVER',
    starterOnly: true,
  },
  {
    id: 'braveMind',
    title: 'Brave Mind — Personalized Meditations for Your Child',
    price: 89,
    compareAt: 149,
    description:
      "The one thing on this page you don't have to make. Five meditations recorded around your child's name and what they're struggling with — delivered in 5 business days.",
    thumbLabel: 'BRAVE MIND COVER',
    image:
      'https://cdn.magicpatterns.com/uploads/mwyho1Kp5as9Bi6QL8akV2/1d804857-ac0b-48ba-a6fc-ea3e7d6b873d.jpg',
  },
  {
    id: 'littleEngineer',
    title: 'Little Engineer Mega Kit',
    price: 19.99,
    compareAt: 27.99,
    description:
      '365 screen-free projects for boys and girls ages 4-10. What they DO once the routine is running.',
    thumbLabel: 'LITTLE ENGINEER COVER',
    image: 'https://cdn.magicpatterns.com/uploads/iQcqbWoPMoubWdsR3KF6xS/kiitt.png',
  },
  {
    id: 'focusLab',
    title: 'NeuroKids Focus System',
    price: 19.99,
    compareAt: 29.99,
    description:
      '100+ printable brain-training exercises. One page a day, ten minutes, no screen.',
    thumbLabel: 'NEUROKIDS COVER',
    image: 'https://cdn.magicpatterns.com/uploads/hUFHnKFTWfjgkBKasJHJZ1/NeuroKids.jpg',
  },
]

export function formatPrice(value: number): string {
  return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`
}
